import { Alert, Box, Chip, Collapse, Grid, LinearProgress, MenuItem, Paper, Stack, Switch, TextField, Typography } from '@mui/material'
import PhoneField from 'components/PhoneField'
import Header from 'components/Header'
import { BasePathProvider } from 'components/Providers'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm, useWatch } from 'react-hook-form'
import { useEffect, useState } from 'react'
import { SubmitButton } from 'components/Buttons'
import { isEqual, pick } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { save } from 'store/settings/campus'
import { FaSave } from 'react-icons/fa'
import { getGradeLevels, getAcademicYearProviders } from 'store/lookup'
// import { enqueueSnackbar } from 'notistack'
// import AvatarIcon from '@mui/icons-material/PersonOutlined'
import * as snackbar from 'utils/snackbar'
import { PHONE_REGEXP } from 'utils/phone'

const initialValues = {
  schoolId: null,
  buildingCode: null,
  ceebCode: null,
  name: null,
  email: null,
  phone: null,
  address: null,
}

export default function SettingsSchoolManagementFormCampus({ data, schools }) {
  const { districtId, campusId } = useParams()

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [academicYears, setAcademicYears] = useState()
  const [stackData, setStackData] = useState()
  const [rawData, setRawData] = useState()
  const [gradeLevelTable, setGradeLevelTable] = useState()
  const [activeGradeLevels, setActiveGradeLevels] = useState([])
  const academicYearProvider = useSelector(state => state.lookup.academicYearProviders)?.filter(s => s.isFullYear)

  // const [image, setImage] = useState()

  const gradeLevels = useSelector(state => state.lookup.gradeLevels)

  useEffect(() => {
    gradeLevels || dispatch(getGradeLevels())
  }, [])

  const { t } = useTranslation()

  const basePath = `/settings/school-management/`

  const schema = yup.object().shape({
    schoolId: yup.string().required(t('Required')),
    // buildingCode: yup.string().required('Required'),
    name: yup.string().required(t('Required')),
    address: yup.object({
      street: yup.string().required(t('Required')),
      city: yup.string().required(t('Required')),
      state: yup.string().required(t('Required')),
      zip: yup.string().required(t('Required')),
    }),
    phone: yup.object({
      number: yup
        .string()
        .matches(PHONE_REGEXP, { message: t('Enter a valid phone number'), excludeEmptyString: true })
        .nullable()
        .notRequired(),
    }),
  })

  const { control, handleSubmit, reset, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues: data?.id
      ? {
        ...data,
        phone: data?.phone?.number || null,
      }
      : { ...initialValues },
  })

  // useEffect(() => {
  //   if (data?.id) {
  //     setImage(data?.file?.location)
  //   }
  // }, [data])

  // const handleFile = async event => {
  //   const file = event.target.files[0]

  //   const formData = new FormData()
  //   formData.append('afile', file)
  //   formData.append('campusId', +campusId)
  //   const url = `/api/settings/campus/upload`
  //   const res = await window.fetch(url, { method: 'POST', body: formData })
  //   if (res.status !== 200) {
  //     enqueueSnackbar(res.statusText, { variant: 'error' })
  //   }
  //   const data = await res.json()
  //   setImage(data.location)
  // }

  const onSubmit = async formData => {
    const address = formData.address
    if (!address?.type) address.type = 'work'
    if (data?.address?.id) {
      address.id = data?.address?.id
    }
    const stateData = {
      buildingCode: formData.stateData.buildingCode,
      ceebCode: formData.stateData.ceebCode,
    }
    const pay = pick(formData, ['schoolId', 'name', 'email',])
    pay.schoolId = +pay.schoolId
    console.log('pay', pay)

    const phones = []
    if (formData.phone) {
      const phone = { type: 'work', number: +formData.phone }
      const found = data?.phones?.find(p => p.type === 'work')
      if (found && found?.id) {
        phone.id = found?.id
      }
      phones.push(phone)
    }
    const payload = {
      ...pay,
      address,
      stateData,
      gradeLevelIds: activeGradeLevels,

    }
    if (data?.id) {
      payload.id = data?.id
    }

    if (gradeLevelTable) {
      payload.campusTargetedEnrollments = [{
        ...gradeLevelTable,
        targetedEnrollments: gradeLevelTable.targetedEnrollments?.filter(
          te => te.targetedEnrollment !== '' && te.targetedEnrollment !== null
        ) || []
      }]
    }

    const res = await dispatch(save(payload))

    if (res.payload) {
      navigate(basePath)
    } else {
      console.error(res.error)
      snackbar.error(t('Failed to save record, please try again'))
    }
  }

  const onErrors = errors => console.log(errors)

  useEffect(() => {
    if (data?.id) {
      reset(data)
      if (data?.phone) {
        setValue('phone', data?.phone?.number, { shouldDirty: true })
      }

      setActiveGradeLevels(data?.gradeLevelIds || [])

      if (data?.schoolId && campusId) {
        const providerPromise = academicYearProvider?.length
          ? Promise.resolve({ payload: academicYearProvider })
          : dispatch(getAcademicYearProviders())
        providerPromise.then(res => {
          if (res?.payload?.length > 0) {
            setAcademicYears(res?.payload)
            const temp = []
            res?.payload?.forEach(item => {
              const found = data?.campusTargetedEnrollments?.find(cte => cte.academicYearProviderId === item?.id)
              if (found) {
                temp.push(data?.campusTargetedEnrollments?.find(cte => cte.academicYearProviderId === item?.id))
              } else {
                temp.push({
                  id: null,
                  academicYearProviderId: item?.id,
                  campusId: +campusId,
                  targetedEnrollments: [],
                })
              }
            })
            setStackData(temp)
            setRawData(temp)

            setGradeLevelTable({
              id:
                data?.campusTargetedEnrollments?.find(cte => cte.academicYearProviderId === res?.payload[0]?.id)?.id ||
                null,
              academicYearProviderId: res?.payload[0]?.id,
              campusId: +campusId,
              targetedEnrollments:
                data?.campusTargetedEnrollments?.find(cte => cte.academicYearProviderId === res?.payload[0]?.id)
                  ?.targetedEnrollments || [],
            })
          }
        })
      }
    }
  }, [data])

  const addRemoveLevel = e => {
    const gradeLevelId = e.target.value
    const currentEnrollments = gradeLevelTable?.targetedEnrollments || []

    const targetedEnrollments = e.target.checked
      ? currentEnrollments.some(item => item.gradeLevelId === gradeLevelId)
        ? currentEnrollments
        : [...currentEnrollments, { gradeLevelId, targetedEnrollment: 0 }]
      : currentEnrollments.filter(item => item.gradeLevelId !== gradeLevelId)

    setGradeLevelTable({ ...gradeLevelTable, targetedEnrollments })
  }

  const setTargetedEnrollment = (gradeLevelId, value, retainedStudents) => {
    const currentEnrollments = gradeLevelTable?.targetedEnrollments || []
    const exists = currentEnrollments.some(item => item.gradeLevelId === gradeLevelId)

    const targetedEnrollments = exists
      ? currentEnrollments.map(item =>
        item.gradeLevelId === gradeLevelId ? { ...item, targetedEnrollment: value, retainedStudents } : item
      )
      : [{ gradeLevelId, targetedEnrollment: value, retainedStudents }]

    setGradeLevelTable({ ...gradeLevelTable, targetedEnrollments })
  }
  const changeAcademicYear = academicYearProviderId => {
    setStackData(prev =>
      prev?.map(item =>
        item.academicYearProviderId === gradeLevelTable?.academicYearProviderId ? gradeLevelTable : item
      )
    )
    setGradeLevelTable(stackData?.find(item => item.academicYearProviderId === academicYearProviderId))
  }

  const schoolId = useWatch({ control, name: 'schoolId' })

  // const reorderArray = arr => {
  //   const half = Math.ceil(arr.length / 2)
  //   return arr.slice(0, half).flatMap((item, i) =>
  //     arr[half + i] !== undefined ? [item, arr[half + i]] : [item]
  //   )
  // }

  const isDisabled = id => {
    if (gradeLevelTable?.academicYearProviderId === +id) return false
    const rawGradeLevelTable = rawData?.find(item => item.academicYearProviderId === gradeLevelTable?.academicYearProviderId)
    return !isEqual(rawGradeLevelTable, gradeLevelTable)
  }

  if (campusId && campusId !== 'new' && !data?.id) return <LinearProgress color="primary" />

  if (!gradeLevels) return null

  // const gradeLevelList = reorderArray(gradeLevels)

  const toggleGradeLevel = (id) => {
    setActiveGradeLevels(prev =>
      prev.includes(id)
        ? prev.filter(gradeId => gradeId !== id)
        : [...prev, id]
    )
  }

  return (
    <BasePathProvider value={`${basePath}`}>
      <Box
        data-component="SettingsSchoolManagementFormDistrict"
        component="form"
        onSubmit={handleSubmit(onSubmit, onErrors)}
        noValidate
        sx={{ overflowY: 'scroll', border: 'none' }}
      >
        <Header title={+districtId && +campusId ? t('Edit Campus') : t('Add Campus')}
          // avatar={
          //   <IconButton component="label" aria-label="district-logo" disabled={data?.id ? false : true}>
          //     <input hidden accept="image/*" type="file" onChange={handleFile} />
          //     {image ? (
          //       <Avatar sx={{ width: 80, height: 80, fontSize: 20 }} variant='square' src={image}>
          //         <AvatarIcon />
          //       </Avatar>
          //     ) : (
          //       <Avatar sx={{ width: 80, height: 80 }}>
          //         {data?.name.split(' ')[0]}
          //       </Avatar>
          //     )}
          //   </IconButton>
          // }
          small close borderBottom
        />
        <Grid container sx={{ p: 3 }} spacing={2}>
          <Grid item xs={6} md={6}>
            <Controller
              name="schoolId"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label={t('School')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                    disabled={data?.schoolId}
                  >
                    {schools.map((item, index) => (
                      <MenuItem key={index} value={item?.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )
              }}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <Controller
              name="name"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    fullWidth
                    size="small"
                    label={t('Name')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <Controller
              name="stateData.buildingCode"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    fullWidth
                    size="small"
                    label={t('Building Code')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <Controller
              name="stateData.ceebCode"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    fullWidth
                    size="small"
                    label={t('CEEB Code')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Controller
              name="address.street"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    fullWidth
                    size="small"
                    label={t('Address')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={7} md={7}>
            <Controller
              name="address.city"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    fullWidth
                    size="small"
                    label={t('City')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={2.5} md={2.5}>
            <Controller
              name="address.state"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    fullWidth
                    size="small"
                    label={t('State')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={2.5} md={2.5}>
            <Controller
              name="address.zip"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    fullWidth
                    size="small"
                    label={t('Zip')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                  />
                )
              }}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <PhoneField
              name="phone.number"
              control={control}
              label={t('Phone')}
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              name="email"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <TextField
                    fullWidth
                    size="small"
                    label={t('Email')}
                    error={!!fieldState.error}
                    {...field}
                    InputLabelProps={{ shrink: field.value ? true : false }}
                  />
                )
              }}
            />
          </Grid>
        </Grid>

        <Box sx={{ mx: 3 }}>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ display: 'block', mb: 1.5, fontWeight: 600, fontSize: 14 }}
          >
            {t('Active Grade Levels')}
          </Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {gradeLevels.map((grade) => {
              const isActive = activeGradeLevels.includes(grade.id)

              return (
                <Chip
                  key={grade.id}
                  label={grade.name}
                  disabled={!schoolId}
                  onClick={() => toggleGradeLevel(grade.id)}
                  color={isActive ? 'primary' : 'default'}
                  variant={isActive ? 'filled' : 'outlined'}
                  clickable
                  sx={{
                    borderRadius: '8px',
                    fontWeight: isActive ? 600 : 400,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: isActive ? 'primary.dark' : 'action.hover',
                    }
                  }}
                />
              )
            })}
          </Box>
        </Box>


        {data?.id && data?.district?.type === 'school' && (
          <Box sx={{ mx: 3, mt: 4 }}>
            <Typography
              variant="overline"
              color="text.secondary"
              sx={{ display: 'block', mb: 1.5, fontWeight: 600, fontSize: 14 }}
            >
              {t('Grade Enrollments')}
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} >
                <TextField
                  disabled={!schoolId}
                  select
                  fullWidth
                  size="small"
                  label={t('Academic Year')}
                  onChange={e => changeAcademicYear(e.target.value)}
                  value={gradeLevelTable?.academicYearProviderId || ''}
                >
                  {academicYears?.map((item, index) => (
                    <MenuItem key={index} value={item.id} disabled={isDisabled(item.id)}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
                {(() => {
                  const raw = rawData?.find(item => item.academicYearProviderId === gradeLevelTable?.academicYearProviderId)
                  return !isEqual(raw, gradeLevelTable) ? (
                    <Alert severity="warning" sx={{ mt: 1 }}>
                      {t('You have unsaved enrollment changes. Save or discard before switching academic years.')}
                    </Alert>
                  ) : null
                })()}
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {gradeLevels.map((grade, index) => {
                    const currentEnrollment = gradeLevelTable?.targetedEnrollments?.find(
                      item => item.gradeLevelId === grade?.id
                    )
                    const isSelected = !!currentEnrollment

                    return (
                      <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                        <Paper
                          variant="outlined"
                          sx={{
                            p: 2,
                            transition: 'all 0.2s ease-in-out',
                            borderColor: isSelected ? 'primary.main' : 'divider',
                            bgcolor: isSelected ? 'action.hover' : 'background.paper',
                            opacity: !schoolId ? 0.6 : 1,
                          }}
                        >
                          <Stack
                            flexDirection="row"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ mb: isSelected ? 2 : 0, transition: 'margin 0.2s' }}
                          >
                            <Typography
                              variant="subtitle2"
                              fontWeight={isSelected ? '600' : '500'}
                              color={isSelected ? 'primary.main' : 'text.primary'}
                            >
                              {grade.name}
                            </Typography>
                            <Switch
                              disabled={!schoolId}
                              size="small"
                              color="primary"
                              value={grade.id}
                              checked={isSelected}
                              onChange={addRemoveLevel}
                            />
                          </Stack>

                          <Collapse in={isSelected}>
                            <Stack direction="column" spacing={1}>
                              <TextField
                                disabled={!schoolId}
                                onChange={e => setTargetedEnrollment(grade?.id, e.target.value, currentEnrollment?.retainedStudents || 0)}
                                fullWidth
                                size="small"
                                type="number"
                                label={t('Targeted Enrollment')}
                                placeholder="0"
                                value={currentEnrollment?.targetedEnrollment || ''}
                                InputProps={{ inputProps: { min: 0 } }}
                                sx={{ bgcolor: 'background.paper' }}
                              />
                              <TextField
                                disabled={!schoolId}
                                onChange={e => setTargetedEnrollment(grade?.id, currentEnrollment?.targetedEnrollment || 0, e.target.value)}
                                fullWidth
                                size="small"
                                type="number"
                                label={t('Retained')}
                                placeholder="0"
                                value={currentEnrollment?.retainedStudents || ''}
                                InputProps={{ inputProps: { min: 0 } }}
                                sx={{ bgcolor: 'background.paper' }}
                              />
                            </Stack>
                          </Collapse>
                        </Paper>
                      </Grid>
                    )
                  })}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        )}

        <Stack flexDirection={'row'} justifyContent={'flex-end'} sx={{ mr: 3, mt: 3, mb: 3 }}>
          <SubmitButton
            onClick={handleSubmit(onSubmit)}
            startIcon={<FaSave />}
            icon={null}
            title={t('Save')}
            color="primary"
          />
        </Stack>
      </Box>
    </BasePathProvider>
  )
}
